<template>
  <div class="widget-custom-in interface" v-if="countryId > 0">
    <template v-for="el in mpkList" :key="el.id">
      <p class="title" v-if="!el.parentId">
        <router-link :to="router(el)">{{ el.name }}</router-link>
      </p>
      <ul v-else>
        <li>
          <router-link :to="router(el)">{{ el.name }}</router-link>
        </li>
      </ul>
    </template>
  </div>
  <div class="widget-custom-in" v-else>
    <SelectComponent
      class="mr-6"
      :options="countryList"
      v-model="selectedCountryId"
      :settings="{ placeholder: 'Выберите страну' }"
    />
    <ButtonComponent mod="gradient-bg" @click="goTo">Перейти</ButtonComponent>
  </div>
</template>

<script>
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import SelectComponent from '@/common/components/SelectComponent.vue';
  import Utils from '@/common/utils';

  import API from '../api/widgetElement';

  export default {
    name: 'Widget5',
    components: {
      ButtonComponent,
      SelectComponent,
    },
    props: {
      countryId: {
        type: Number,
        default: null,
      },
    },
    watch: {
      countryId: function (/*newValue*/) {
        this.loadMpk();
      },
    },
    data() {
      return {
        countryList: [],
        mpkList: [],
        selectedCountryId: 0,
      };
    },
    created() {
      this.loadMpk();
      this.loadCountries();
    },
    methods: {
      goTo() {
        if (this.selectedCountryId && this.selectedCountryId > 0) {
          this.$router.push({ name: 'Commissions', query: { countryId: this.selectedCountryId } });
        }
      },
      loadCountries() {
        this.countryList = [{ id: 0, text: 'Выберите страну' }];
        Utils.loadSelectOptions('countryList', this.countryList, {}, false);
      },
      loadMpk() {
        if (this.countryId > 0) {
          API.getMpk({ countryId: this.countryId }).then((response) => {
            this.mpkList = response.data;
          });
        }
      },
      router(el) {
        var _type = el.parentId > 0 ? 'rg' : 'mp';
        return { name: 'CommissionCard', params: { id: el.id, type: _type, action: 'view' } };
      },
    },
  };
</script>

<style lang="scss" scoped>
  .widget-custom-in.interface {
    max-height: 170px;
  }
  .widget-custom-in .title a {
    font-weight: 500;
  }
  .widget-custom-in a {
    color: #000;
  }
  .widget-custom-in a:hover {
    color: #007bff;
  }
</style>
